import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import getImage from '../../../utils/getOptimizedImage'
import media from 'styled-media-query'
import useKevelAnalytics from '../../../hooks/kevelAPI/useKevelAnalytics'
import BlogCopyBlock from './BlogCopyBlock'
import getCloudinaryUrl from '@/utils/getCloudinaryUrl'
import useImageProps from '@/hooks/useImageProps'
import Image from '@/components/Image'
import IconPlay from '@/components/IconPlay'
import { useInView } from 'react-intersection-observer'
import { ArrowRight } from 'react-bootstrap-icons'
import LinkButton from '../../atoms/LinkButton/LinkButton'

const Style = styled.div`
  border-radius: 20px;
  overflow: hidden;
  position: relative;

  .ad_icon {
    position: absolute;
    top: 10px;
    right: 15px;
    background-color: ${(props) => props.theme.lightGray};
    color: ${(props) => props.theme.charcoal};
    padding: 3px 7px;
    font-size: 15px;
    border-radius: 4px;
    opacity: 0.9;
    @media (max-width: 900px) {
      opacity: 1;
    }
  }

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
  @media (max-width: 600px) {
    grid-template-columns: auto;
  }
  min-height: 390px;

  & > div:nth-child(1) {
    justify-self: end;
    ${(props) =>
      props.reverse
        ? css`
            justify-self: start;
          `
        : ''};
  }

  & > div:nth-child(2) {
    min-width: 300px;
    .play {
      color: white !important;
    }
    @media (max-width: 900px) {
      justify-self: center;
      order: -1;
      img {
        margin: 0 auto;
      }
    }
    i {
      font-size: 80px;
      margin: 0 auto;
    }
    height: 100%;
    min-height: 300px;
    width: 100%;

    ${(props) =>
      props.reverse
        ? css`
            order: -1;
            justify-self: start;
          `
        : ''};
  }
`
const Modal = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 1000;
  i {
    position: absolute;
    top: 25px;
    right: 50px;
    color: white;
    font-size: 60px;
    cursor: pointer;
  }

  iframe {
    left: calc(50vw - 380px);
    width: 820px;
    height: 461px;
    top: calc(50vh - 210px);
    z-index: 9999;
    position: absolute;
    ${media.lessThan('medium')`
    left: 0%;
    width: 100%;
    height: 280px;
  `};
  }
`

const ContentPicture = ({
  video,
  reverse,
  charcoal,
  link,
  title,
  content,
  image,
  gray,
  spotlight,
  recordUrlClick,
  ctaName,
  adRef,
  house,
  impressionUrl,
  clickUrl,
  location,
  zoneId,
  ...rest
}) => {
  const [showVideo, setShowVideo] = useState(false)

  const { onImpression, onClick } = useKevelAnalytics({
    impressionUrl,
    zoneId,
    clickUrl
  })

  const { ref } = useInView({
    onChange: (inView) => onImpression(inView),
    rootMargin: '-200px -50px'
  })

  const [locations, setLocations] = useState(null)
  useEffect(() => {
    setLocations(window.location)
  }, [])

  const url = locations?.pathname?.includes('blog')
  const toggleVideo = () => {
    setShowVideo(!showVideo)
  }

  useEffect(() => {
    document.querySelector('html').style.overflow = showVideo ? 'hidden' : null
  }, [showVideo])

  return (
    <>
      {!url ? (
        <>
          <Style
            {...rest}
            ref={ref}
            image={image && getImage(image)}
            reverse={reverse}
            charcoal={charcoal}
            gray={gray}
            className="rounded-[20px] border border-blue-50 bg-blue-25"
          >
            <div className="flex flex-col justify-center gap-4 p-8 lg:p-16">
              {adRef && (
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <div className="font-semibold">Ad</div>
                  <div className="">•</div>
                  {adRef}
                </div>
              )}

              <div>
                {link ? (
                  <a
                    onClick={onClick}
                    className="text-decoration-none"
                    href={link.link}
                  >
                    <h4 className="font-FieldsVariable text-3xl tracking-normal text-gray-1100 md:text-4xl md:tracking-normal">
                      {title}
                    </h4>
                  </a>
                ) : (
                  <h4 className="font-FieldsVariable text-3xl tracking-normal text-gray-1100 md:text-4xl md:tracking-normal">
                    {title}
                  </h4>
                )}
              </div>

              <p className="text-gray-800 md:mt-2">{content}</p>
              {link && (
                <div className="mt-4">
                  <LinkButton
                    label={link.text}
                    href={link.link}
                    onClick={() => onClick()}
                    size="large"
                    underline="always"
                    iconElement={
                      <ArrowRight
                        size="16"
                        className="ml-1"
                      />
                    }
                  />
                </div>
              )}
            </div>

            <div
              className={`relative flex ${
                video ? 'cursor-pointer' : 'cursor-default'
              } items-center`}
              onClick={() => {
                if (video) toggleVideo()
              }}
              role="button"
            >
              <Image
                {...useImageProps({
                  aspectRatio: 'video',
                  loading: 'lazy',
                  src:
                    !house && spotlight
                      ? image
                      : getCloudinaryUrl(
                          image.split('/upload/').pop(),
                          'q_50,w_640,ar_4:3,c_fill'
                        )
                })}
              />

              {
                !house && spotlight && (
                  <div className="ad_icon">Ad</div>
                ) /* Don't show Ad icon if the ad is coming from rehabpath (ie house ad) */
              }
              <a
                href={!video && link?.link}
                className="absolute left-0 top-0 size-full"
                onClick={() => onClick()}
              >
                {video && (
                  <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white drop-shadow-[0_0_6px_rgba(0,0,0,0.10)]">
                    <IconPlay customCss="size-20" />
                  </div>
                )}
              </a>
            </div>
          </Style>
          {video && showVideo && (
            <Modal onClick={toggleVideo}>
              <iframe
                title={'destingation'}
                id="ytplayer"
                type="text/html"
                src={`https://www.youtube.com/embed/${video}?${'rel=0&showinfo=0&autohide=1&autoplay=1&vq=hd1080&fs=1'}`}
                frameBorder="0"
                allowfullscreen="allowfullscreen"
              />
            </Modal>
          )}
        </>
      ) : (
        <BlogCopyBlock />
      )}
    </>
  )
}

export default ContentPicture
